import NewsCardCommon from './containers/newsCardCommon'

export {default as NewsCardCommonLayout} from './components/newsCardCommonLayout'

export default NewsCardCommon
